const DB_NAME = 'anotequest-cache';
const DB_VERSION = 1;
const STORE = 'kv';

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function withStore(mode, fn) {
  const db = await openDb();
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, mode);
      const store = tx.objectStore(STORE);
      const result = fn(store);
      tx.oncomplete = () => resolve(result);
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(tx.error);
    });
  } finally {
    db.close();
  }
}

function keyForImages(userId) {
  return `images:${userId || 'anon'}`;
}

export async function loadCachedImages(userId) {
  try {
    const key = keyForImages(userId);
    const value = await withStore('readonly', (store) => {
      return new Promise((resolve, reject) => {
        const req = store.get(key);
        req.onsuccess = () => resolve(req.result || null);
        req.onerror = () => reject(req.error);
      });
    });

    if (!value) return null;
    if (!Array.isArray(value.images)) return null;
    return value.images;
  } catch (e) {
    console.warn('Failed to load cached images from IndexedDB:', e?.message || e);
    return null;
  }
}

export async function saveCachedImages(userId, images) {
  try {
    const key = keyForImages(userId);
    await withStore('readwrite', (store) => {
      store.put({ images, savedAt: Date.now() }, key);
    });
  } catch (e) {
    console.warn('Failed to save cached images to IndexedDB:', e?.message || e);
  }
}

export async function clearCachedImages(userId) {
  try {
    const key = keyForImages(userId);
    await withStore('readwrite', (store) => {
      store.delete(key);
    });
  } catch (e) {
    console.warn('Failed to clear cached images from IndexedDB:', e?.message || e);
  }
}
